import {
  getBalanceCheckerEditorSettings,
  setBalanceCheckerEditorSettings,
} from "123tcs-common/utils/storage";
import PropTypes from "prop-types";
import React, { createContext, useContext, useMemo, useState } from "react";

const EditorSettingsContext = createContext();
const defaultSettings = {
  showCaptcha: false,
  showVerificationCode: true,
  errors: [],
  showHTML: true,
};

export function EditorSettingsProvider({ children }) {
  // States
  const [settings, setSettings] = useState({
    ...defaultSettings,
    ...getBalanceCheckerEditorSettings(),
  });

  // Functions
  const saveSettings = (newSettings) => {
    setSettings(newSettings);
    setBalanceCheckerEditorSettings(newSettings);
  };

  const resetSettings = () => {
    saveSettings(defaultSettings);
  };

  // Memos
  const getStates = useMemo(() => {
    return { settings, saveSettings, resetSettings };
  }, [settings, saveSettings, resetSettings]);

  // Render
  return (
    <EditorSettingsContext.Provider value={getStates}>
      {children}
    </EditorSettingsContext.Provider>
  );
}

EditorSettingsProvider.propTypes = {
  children: PropTypes.element,
};

EditorSettingsProvider.defaultProps = {
  children: null,
};

export const useEditorSettings = () => useContext(EditorSettingsContext);
